module.exports = __webpack_public_path__ + "img/PRINX-icon.ac40b750.png";